/**
 * Добавляет новую пару ключ-значение к текущим параметрам поиска URL и обновляет адресную строку браузера.
 *
 * @param {string} queryKey - Ключ, который будет добавлен к параметрам поиска.
 * @param {string} queryValue - Значение, которое будет добавлено к ключу.
 *
 * */

export const appendSearchParams = (queryKey: string, queryValue: string) => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.get(queryKey) === queryValue) return;
    searchParams.append(queryKey, queryValue);
    const newQueryString = `?${searchParams.toString()}`;
    window.history.pushState({}, '', newQueryString);
};
